/*
 * Photo Cutouts: Hotjar, only for visitors who allow analytics.
 *
 * Rendered from snippets/pco-hotjar.liquid with the site id (theme setting
 * "Hotjar site ID") on the script tag as data-hotjar-id. Nothing of Hotjar's
 * is requested, and no _hj cookie can be set, until Shopify's consent API
 * (window.Shopify.customerPrivacy, the same one the cookie banner writes to)
 * says analytics are allowed:
 *
 * - a visitor who accepted on an earlier page: loads as soon as the API is up;
 * - a visitor who accepts during this visit: loads on 'visitorConsentCollected';
 * - a visitor who declines, or never answers where the banner asks: never loads.
 *
 * Where the shop does not ask for consent (a region with the banner off),
 * analyticsProcessingAllowed() is true and Hotjar loads, as Shopify's own
 * pixels do. A visitor who withdraws consent stops being recorded from the
 * next page, because this file then never loads Hotjar again.
 *
 * Not a custom pixel: those run in a sandboxed iframe and cannot see the page,
 * which is the whole of what Hotjar records.
 */
(function () {
  var script = document.currentScript;
  var id = script && Number(script.getAttribute('data-hotjar-id'));
  if (!id || window.pcoHotjar) return;
  window.pcoHotjar = { id: id, loaded: false };

  function load() {
    if (window.pcoHotjar.loaded || window.hj) return;
    window.pcoHotjar.loaded = true;
    /* Hotjar's standard tracking code (hjsv 6), unminified. */
    window.hj =
      window.hj ||
      function () {
        (window.hj.q = window.hj.q || []).push(arguments);
      };
    window._hjSettings = { hjid: id, hjsv: 6 };
    var tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://static.hotjar.com/c/hotjar-' + id + '.js?sv=6';
    document.head.appendChild(tag);
  }

  function analyticsAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    try {
      return cp.analyticsProcessingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  /* Answered during this visit (the banner's Accept, or its preferences). */
  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail && event.detail.analyticsAllowed) load();
  });

  /* Answered on an earlier visit. Without the API there is no consent to read, so nothing loads. */
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && analyticsAllowed()) load();
    });
  }
})();
